import { NgClass } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Checkbox } from 'primeng/checkbox';
import { InputText } from 'primeng/inputtext';
import { HelperService } from '../../../../core/services/helper.service';
import { I18nService } from '../../../../core/services/i18n.service';
import { PaymentData } from '../../../interfaces/payment/payment-data';
import { PaymentInvalidFlags } from '../../../interfaces/payment/payment-invalid-flags';

@Component({
  selector: 'edit-form-email-notification',
  imports: [
    InputText,
    ReactiveFormsModule,
    FormsModule,
    Checkbox,
    NgClass
  ],
  templateUrl: './edit-form-email-notification.component.html',
})
export class EditFormEmailNotificationComponent {

  @Input() paymentData: PaymentData;
  @Input() paymentInvalidFlags: PaymentInvalidFlags;

  public i18n = inject(I18nService);
  public helper = inject(HelperService);

}
